import React, { useEffect, useState, useContext, useCallback } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import { getManagers, getLogs, deleteLog } from '../../../api/managerApi';
import '../../../css/users.css';

function LogList() {
  const { token } = useContext(AuthContext);
  const [companies, setCompanies] = useState([]);
  const [selectedComCode, setSelectedComCode] = useState('');
  const [logs, setLogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getManagers(token)
      .then((data) => setCompanies(Array.isArray(data) ? data : []))
      .catch((err) => console.error('회사 목록 조회 실패:', err));
  }, [token]);

  const fetchLogs = useCallback(async (comCode) => {
    if (!comCode) {
      setLogs([]);
      return;
    }

    try {
      setLoading(true);
      const data = await getLogs({ page: 1, limit: 200, comCode }, token);
      setLogs(Array.isArray(data?.logs) ? data.logs : []);
    } catch (err) {
      console.error('로그 목록 조회 실패:', err);
      alert(err?.response?.data?.message || '로그 목록 조회 중 오류가 발생했습니다.');
      setLogs([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (selectedComCode) {
      fetchLogs(selectedComCode);
    }
  }, [selectedComCode, fetchLogs]);

  const handleComCodeChange = (e) => {
    setSelectedComCode(e.target.value);
    setSearchTerm('');
  };

  const handleDelete = async (logId) => {
    if (!selectedComCode) return;
    if (!window.confirm('해당 로그를 삭제하시겠습니까?')) return;

    try {
      await deleteLog(logId, selectedComCode, token);
      await fetchLogs(selectedComCode);
    } catch (err) {
      console.error('로그 삭제 실패:', err);
      alert(err?.response?.data?.message || '로그 삭제 중 오류가 발생했습니다.');
    }
  };

  const filteredLogs = logs.filter((log) => {
    const keyword = searchTerm.toLowerCase();
    if (!keyword) return true;

    return (
      String(log.log_userId || '').toLowerCase().includes(keyword) ||
      String(log.log_userName || '').toLowerCase().includes(keyword) ||
      String(log.log_url || '').toLowerCase().includes(keyword) ||
      String(log.log_ip || '').toLowerCase().includes(keyword) ||
      String(log.log_method || '').toLowerCase().includes(keyword)
    );
  });

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-3 users-header">
            <h4 className="mb-0">접속 로그 목록</h4>
            <div>
              <select
                className="form-select"
                style={{ minWidth: '180px' }}
                value={selectedComCode}
                onChange={handleComCodeChange}
              >
                <option value="">회사를 선택해주세요.</option>
                {companies.map((c) => (
                  <option key={c.M_ComCode} value={c.M_ComCode}>
                    {c.M_ComName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <form className="row g-2 mb-3 users-search-form" onSubmit={(e) => e.preventDefault()}>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="아이디/이름/URL/IP/메소드 검색"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={!selectedComCode}
              />
            </div>
            <div className="col-auto">
              <button className="btn btn-outline-secondary" type="button" onClick={() => setSearchTerm('')}>
                초기화
              </button>
            </div>
          </form>

          {!selectedComCode ? (
            <div className="users-empty">
              <p>회사를 선택해주세요.</p>
            </div>
          ) : loading ? (
            <div className="users-empty">
              <div className="spinner-border text-secondary" role="status" />
              <p>로그를 불러오는 중입니다.</p>
            </div>
          ) : filteredLogs.length === 0 ? (
            <div className="users-empty">
              <p>로그 데이터가 없습니다.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-nowrap align-middle table-hover mb-0 users-table">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '8%' }}>ID</th>
                    <th style={{ width: '12%' }}>아이디</th>
                    <th style={{ width: '12%' }}>이름</th>
                    <th style={{ width: '10%' }}>IP</th>
                    <th style={{ width: '30%' }}>URL</th>
                    <th style={{ width: '12%' }}>메소드</th>
                    <th style={{ width: '10%' }}>시간</th>
                    <th style={{ width: '6%' }} className="text-center">관리</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLogs.map((log) => (
                    <tr key={log.log_id}>
                      <td>{log.log_id}</td>
                      <td>{log.log_userId}</td>
                      <td>{log.log_userName}</td>
                      <td>{log.log_ip || '-'}</td>
                      <td className="text-truncate" style={{ maxWidth: '320px' }}>{log.log_url}</td>
                      <td>{log.log_method}</td>
                      <td>{log.log_time ? String(log.log_time).replace('T', ' ').slice(0, 19) : '-'}</td>
                      <td className="text-center">
                        <button className="btn btn-danger btn-sm" onClick={() => handleDelete(log.log_id)}>
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LogList;
